import Vue from 'vue'
import Router from 'vue-router'
// import Home from '@/views/home.vue'
import PropertiesPage from '@/components/property/property-page.vue'
import BenefitsPage from '@/components/common/benefits-page.vue'
import ViewpointsPage from '@/components/viewpoint/viewpoints-page.vue'
import TeamsPage from '@/components/team/teams-page.vue'
import TeamPage from '@/components/team/team-page.vue'
// import UserDashboard from '@/components/user/user-dashboard.vue'
// import AuthLogin from '@/components/auth/auth-login.vue'
// import AuthLogout from '@/components/auth/auth-logout.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  routes: [
    {
      path: '/',
      redirect: '/mls',
    },
    {
      path: '/mls',
      name: 'mls',
      component: PropertiesPage,
    },
    {
      path: '/favorites',
      name: 'favorites',
      component: PropertiesPage,
    },
    {
      path: '/properties/:subSection',
      name: 'properties',
      component: PropertiesPage,
    },
    {
      path: '/viewpoints',
      name: 'viewpoints',
      component: ViewpointsPage,
    },
    {
      path: '/teams',
      name: 'teams',
      component: TeamsPage
    },
    {
      path: '/team/:teamId?',
      name: 'team',
      component: TeamPage
    },
    {
      path: '/benefits',
      name: 'benefits',
      component: BenefitsPage
    },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   this generates a separate chunk (about.[hash].js) for this route
    //   which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ '@/views/about.vue'),
    // },
    {
      // catch all use case
      path: '*',
      redirect: '/',
    },
  ]
})
